import "@/App.css";
import { LanguageProvider } from "@/context/LanguageContext";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Services from "@/components/landing/Services";
import VirtualTour from "@/components/landing/VirtualTour";
import Team from "@/components/landing/Team";
import WhyUs from "@/components/landing/WhyUs";
import Reviews from "@/components/landing/Reviews";
import ContactSchedule from "@/components/landing/ContactSchedule";
import Footer from "@/components/landing/Footer";
import WhatsAppFloat from "@/components/landing/WhatsAppFloat";

function App() {
  return (
    <LanguageProvider>
      <div className="App" data-testid="app-root">
        <Header />
        <main>
          <Hero />
          <Services />
          <VirtualTour />
          <Team />
          <WhyUs />
          <Reviews />
          <ContactSchedule />
        </main>
        <Footer />
        <WhatsAppFloat />
      </div>
    </LanguageProvider>
  );
}

export default App;
